class OrderHistoryError extends Error {
  title = "Whoa, that's not in the playbook";

  constructor(args?: {message?: string; title?: string; source?: Error}) {
    const message = args?.message || 'Something went wrong while trying to load the page. Please try again.';
    super(message);
    if (args?.title) {
      this.title = args.title;
    }
    this.stack = this.truncateErrorStackTrace(args?.source || this);
  }

  private truncateErrorStackTrace(error: Error, maxLines = 10): string {
    if (!error.stack) {
      return error.message;
    }

    const stackLines = error.stack.split('\n');
    if (stackLines.length <= maxLines) {
      return error.stack;
    }
    const truncatedStack = stackLines.slice(0, maxLines + 1).join('\n');
    return `${error.message}\n${truncatedStack}`;
  }
}

function isOrderHistoryError(error: Error): error is OrderHistoryError {
  return error instanceof OrderHistoryError;
}

class NotFoundError extends OrderHistoryError {
  constructor(source?: Error) {
    const message = "The page you're looking for may not exist or may have moved";
    super({message, source});
  }
}

class UnauthorizedError extends OrderHistoryError {
  constructor(source?: Error) {
    const message = 'You do not have permission to access that page';
    super({message, source});
  }
}

export {OrderHistoryError, isOrderHistoryError, NotFoundError, UnauthorizedError};
